export const register_ok_title = " ";
export const register_ok_description_part_01 =
  "¡Preparaos para una dura temporada!";
export const register_ok_description_part_02 =
  "En los próximos días iremos actualizando la web con más novedades, así que estate atento al Discord oficial y a nuestro Twitter.";
